export default "__VITE_ASSET__CNxp$Uah__"